import { render, staticRenderFns } from "./ShopSwitcher.vue?vue&type=template&id=29f57387&scoped=true&"
import script from "./ShopSwitcher.vue?vue&type=script&lang=js&"
export * from "./ShopSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ShopSwitcher.vue?vue&type=style&index=0&id=29f57387&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f57387",
  null
  
)

export default component.exports